import axios from 'axios';

const overrideDefaults = {
    withCredentials: true
};

const axiosInstance = axios.create(overrideDefaults);

export default axiosInstance;
